import React, { PureComponent } from "react";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import VerticalSpace from "./components/VerticalSpace";
import AppConfig from "../../config/appconfig.json";
import KBELogo from "../account/img/kbe-Logo-66454.png";

export default class ReceiptDetails extends PureComponent {

    constructor(props) {
        super(props);
        const rcpNumber = this.props.location.state
            ? this.props.location.state.receiptNumber
            : null;
        const invNumber = this.props.location.state
            ? this.props.location.state.invoiceNumber
            : null;
        this.state = { ReceiptNumber: rcpNumber, InvoiceNumber: invNumber, errMsg: "", isReceiptError: false };
        // console.log(rcpNumber);
    }

    componentDidMount() {
        const rcpNumber = this.state.ReceiptNumber;
        let isGetReceiptDetailsFailed = false;
        // Call Back-End Services
        fetch(`${AppConfig.BACK_END_URL}/APIClient/GetReceiptDetails?receiptnumber=` + rcpNumber)
            .then(response => {
                // console.log(response);
                if (response.ok === false) {
                    isGetReceiptDetailsFailed = true;
                }
                return response.json();
            })
            .then(json => {
                if (isGetReceiptDetailsFailed) {
                    const respObjErr = JSON.parse(json);
                    this.setState({ isReceiptError: true, errMsg: respObjErr.Message });
                    const rcp = localStorage.getItem("inv_" + rcpNumber);
                    if (rcp) {
                        const respObj = JSON.parse(rcp);
                        this.setState({ receipt: respObj });
                    }
                } else {
                    const respObj = JSON.parse(json);
                    //console.log(respObj);
                    if (respObj) {
                        this.setState({ receipt: respObj[0] });
                        localStorage.setItem("inv_" + rcpNumber, JSON.stringify(respObj[0]));
                    }
                }
            })
            .catch(() => {
                console.log(
                    "Something went wrong when retrieving receipt. Please try again."
                );
                const rcp = localStorage.getItem("inv_" + rcpNumber);
                if (rcp) {
                    const respObj = JSON.parse(rcp);
                    this.setState({ receipt: respObj });
                }
            });
    }

    render() {
        return (
            <div>
                <div className="account">
                    <div className="account__wrapper">
                        <div className="account__card">
                            <div className="account__head">
                                <img src={KBELogo} alt="logo" />
                            </div>
                            <div className="card__title">
                                <center>
                                    <h4 className="bold-text">Payment</h4>
                                </center>
                                <br />
                            </div>
                            <div>
                                {this.state.isReceiptError ? (<div>
                                    <List component="nav">
                                        <Divider />
                                        <ListItem >
                                            <Grid container spacing={0}>
                                                <Grid item xs={12}>
                                                    <ListItemText>
                                                        <div className="form__form-group-field list-text-red text-center list-text-full">
                                                            {this.state.errMsg}
                                                        </div>
                                                    </ListItemText>
                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                        <Divider />
                                    </List>
                                </div>) : (
                                        <List component="nav">
                                            <Divider />
                                            <ListItem >
                                                <Grid container spacing={0}>
                                                    <Grid item xs={4}>
                                                        <ListItemText>
                                                            <div className="list-text-full">
                                                                Receipt Number:
                                                    </div>
                                                            <div className="list-text-full">
                                                                Invoice Number:
                                                    </div>
                                                            <div className="list-text-full">
                                                                Invoice Amount:
                                                    </div>
                                                            <div className="list-text-full">
                                                                Amount Paid:
                                                    </div>
                                                            <div className="list-text-full">
                                                                Payment Mode:
                                                    </div>
                                                            <div className="list-text-full">
                                                                Payment Date:
                                                    </div>
                                                            <div className="list-text-full">
                                                                Remarks:
                                                    </div>
                                                        </ListItemText>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        {this.state.receipt ? (
                                                            <ListItemText>
                                                                <div className="list-text-full">
                                                                    {this.state.receipt.ReceiptNumber}
                                                                </div>
                                                                <div className="list-text-full">
                                                                    {this.state.InvoiceNumber}
                                                                </div>
                                                                <div className="list-text-full">
                                                                    {this.state.receipt.Amount}
                                                                </div>
                                                                <div className="list-text-full">
                                                                    {this.state.receipt.Amount}
                                                                </div>
                                                                <div className="list-text-full">
                                                                    {this.state.receipt.PaymentMode}
                                                                </div>
                                                                <div className="list-text-full">
                                                                    {this.state.receipt.Date}
                                                                </div>
                                                                <div className="list-text-full">
                                                                    {this.state.receipt.Remarks}
                                                                </div>
                                                            </ListItemText>
                                                        ) : (
                                                                <ListItemText></ListItemText>)}
                                                    </Grid>
                                                </Grid>
                                            </ListItem>
                                            <Divider />
                                        </List>
                                    )}
                                <VerticalSpace />
                            </div>
                            <SimpleBottomNavigation value={3} />
                        </div>
                    </div>
                </div>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/pages/main/ReceiptDetails.js